import Vue from 'vue';
import exerciseselector from './exerciseselector.vue';
import i18n from "./i18n";

export function addExerciseSelectorViewModel(exercisesTitle, baseUrl, suggestExerciseUrl, staticUrl) {
    new (Vue.extend(exerciseselector))({
        el: '#exerciseSelectorContainer',
        i18n,
        propsData: {
            exercisesTitle: exercisesTitle,
            baseUrl: baseUrl,
            suggestExerciseUrl: suggestExerciseUrl,
            staticUrl: staticUrl,
        }
    });
}